<template>
    <div>
        <select class="form-control" @input="changed">
            <option value>All</option>
            <option value='true'>Active</option>
            <option value='false'>Not Active</option>
        </select>
    </div>
</template>
<script>
    export default {
        props: ['column'],
        methods: {
            changed(selected) {
                let res = {};

                for (let i = 0; i < this.$lang.all.length; i++) {
                    let lang = this.$lang.all[i];
                    if(lang == this.$lang.current ){
                        res[`q_${this.column.key}->${this.$lang.current}`] =  selected.target.value ? selected.target.value : null;
                    }else{
                        res[`q_${this.column.key}->${lang}`] = null;
                    }
                }

                this.$emit('input', res );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/metronic/table/header/BooleanTransHeader.vue